import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/Button'
import { Building2, TrendingUp, Home, DollarSign } from 'lucide-react'

export function LogoutSuccessPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-blue-50 flex items-center justify-center p-4">
      <div className="max-w-2xl mx-auto text-center">
        {/* Logo */}
        <div className="mb-8">
          <div className="mx-auto w-20 h-20 bg-white rounded-full shadow-lg flex items-center justify-center mb-6">
            <Building2 className="w-10 h-10 text-primary-600" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            You've Successfully Logged Out
          </h1>
        </div>

        {/* Motivational REI Slogan */}
        <div className="bg-white rounded-xl shadow-xl p-8 mb-8">
          <div className="flex justify-center space-x-4 mb-6">
            <Home className="w-8 h-8 text-blue-500" />
            <TrendingUp className="w-8 h-8 text-green-500" />
            <DollarSign className="w-8 h-8 text-primary-600" />
          </div>
          
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            "Build Wealth One Property at a Time"
          </h2>
          
          <p className="text-lg text-gray-600 mb-6">
            Your journey to financial freedom through real estate continues. 
            Every analysis brings you closer to your next great investment opportunity.
          </p>
          
          <div className="border-t pt-6 mt-6">
            <p className="text-gray-500 italic">
              Remember: The best time to invest in real estate was 20 years ago. 
              The second best time is now.
            </p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-4">
          <p className="text-gray-600 mb-4">
            We look forward to seeing you again soon!
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/login">
              <Button size="lg" className="min-w-[200px]">
                Sign Back In
              </Button>
            </Link>
            
            <Link to="/">
              <Button variant="secondary" size="lg" className="min-w-[200px]">
                Go to Homepage
              </Button>
            </Link>
          </div>
        </div>

      </div>
    </div>
  )
}